import axios, { AxiosResponse } from 'axios'; //npm install axios --save //npm install --save es6-promise For IE
import { Constant } from '@/helpers/constant';
import { Rest, RestHeader } from '@/helpers/rest';
import Jobseeker from '@/models/jobseeker';
import JobseekerCareerProfile from '@/models/jobseekerCareerProfile';
import JobseekerEmployment from '@/models/jobseekerEmployment';
import JobseekerEducation from '@/models/jobseekerEducation';
import JobseekerLanguages from '@/models/jobseekerLanguages';
import JobseekerPersonalDetails from '@/models/jobseekerPersonalDetails';
import JobseekerProject from '@/models/jobseekerProject';
import router from '@/router';
import JobseekerConditionalQuestions from '@/models/jobseekerConditionalQuestions';
import JobseekerAssessment from "@/models/jobseekerAssessment";

class JobseekerService {

  axios;
  constructor() {
    this.axios = axios.create({});
  }

  public getAllJobseekers(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/allJobseekers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public createJobseeker(jobseeker,provider) {
    let url = "";
    let formHeader = RestHeader.MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN;
    if(provider == Constant.JOBSEEKER_PROVIDER){
      url = "jobseeker/createJobseeker";
      formHeader = RestHeader.MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN;
    } else if(provider == Constant.EMPLOYER_PROVIDER){
      url = "jobseekerEmployer/createJobseeker";
      formHeader = RestHeader.MULTIPART_FORMDATA_WITH_BEARER_TOKEN;
    }
    return this.axios.post(Constant.SERVER_URL + 'api/'+url, jobseeker,
      { headers: Rest.getHeaders(formHeader) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }



  public preRegJobseeker(jobseeker,provider) {
    let url = "";
    let formHeader = RestHeader.MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN;
    if(provider == Constant.JOBSEEKER_PROVIDER){
      url = "jobseeker/preRegJobseeker";
      formHeader = RestHeader.MULTIPART_FORMDATA_WITHOUT_BEARER_TOKEN;
    } else if(provider == Constant.EMPLOYER_PROVIDER){
      url = "jobseekerEmployer/createJobseeker";
      formHeader = RestHeader.MULTIPART_FORMDATA_WITH_BEARER_TOKEN;
    }
    return this.axios.post(Constant.SERVER_URL + 'api/'+url, jobseeker,
      { headers: Rest.getHeaders(formHeader) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }


  public checkValueExists(value,field): Promise<AxiosResponse<any>> {
    let data ={
      "value":value,
      "field":field,
      "provider":Constant.JOBSEEKER_PROVIDER
    }
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getJobseekerByField', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkValueExistsWithAuth(value,field:string): Promise<AxiosResponse<any>> {
    let data ={
      "value":value,
      "field":field,
      "provider":Constant.JOBSEEKER_PROVIDER
    }
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getJobseekerByFieldWithAuth', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerById(jobseekerId: any): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseeker/' + jobseekerId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          // alert("HRDF Unauthorized");
          // localStorage.clear();
          // router.push('/');
          this.handleUnauthorized();
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public handleUnauthorized() {
    // alert("HRDF Unauthorized");
    localStorage.clear();

    const currentPath = window.location.pathname;
    if (currentPath.includes('indiCourse')) {
        const urlParams = new URLSearchParams(window.location.search);
        const courseId = urlParams.get('courseId');
        if (courseId) {
            router.push(`/courseDetails?courseId=${courseId}`);
        } else {
            router.push('/');
        }
    } else {
        router.push('/');
    }
}
  public getAdminSetting(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/getAdminSettings' , data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerResume(path:string,provider:string): Promise<AxiosResponse<any>> {
    let data = {
      provider: provider,
      filepath: path
    };
    let url ="";
    if(provider == Constant.JOBSEEKER_PROVIDER){
      url = "api/jobseeker/downloadResumeForJobseeker"
    }
    else{
      url ="api/jobseekerEmployer/downloadResumeForJobseeker"
    }
    return this.axios.post(Constant.SERVER_URL + url, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerCareerProfileById(jobseekerCareerProfileId): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerCareerProfile/' + jobseekerCareerProfileId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!")
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerEmploymentById(jobseekerEmploymentId): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerEmployment/' + jobseekerEmploymentId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerEducationById(jobseekerEducationId): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerEducation/' + jobseekerEducationId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerLanguagesById(jobseekerLanguagesId): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerLanguages/' + jobseekerLanguagesId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerPersonalDetailsById(jobseekerPersonalDetailsId): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerPersonalDetails/' + jobseekerPersonalDetailsId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getJobSeekerProjectById(id): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/showJobseekerProject/' + id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerCareerProfile(jobseekerCareerProfile: JobseekerCareerProfile, jobseekerCareerProfileId): Promise<AxiosResponse<any>> {
    jobseekerCareerProfile.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerCareerProfile/' + jobseekerCareerProfileId, jobseekerCareerProfile,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerEmployment(jobseekerEmployment: JobseekerEmployment, jobseekerEmploymentId): Promise<AxiosResponse<any>> {
    jobseekerEmployment.provider = Constant.JOBSEEKER_PROVIDER;

    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerEmployment/' + jobseekerEmploymentId, jobseekerEmployment,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public deleteJobseekerEmployment(id:number): Promise<AxiosResponse<any>> {
   let data={
    provider:Constant.JOBSEEKER_PROVIDER
   } ;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteJobseekerEmployment/' + id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public deleteJobseekerEducation(id:number): Promise<AxiosResponse<any>> {
    let data={
     provider:Constant.JOBSEEKER_PROVIDER
    } ;
     return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteJobseekerEducation/' + id, data,
       { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
         return ag;
       }).catch(err => {
 
         if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
         }
         else if (err == "Error: Request failed with status code 500") {
           return err;
         }
         else if (err == "Error: Request failed with status code 400") {
            alert("Bad Request!");
          return err;
         } else if (err == "Error: Request failed with status code 404") {
           alert("Page Not Found!");
           localStorage.clear();
           router.push('/');
         }
         return err;
         // Manage the state of the application if the request
         // has failed
       });
   }
   public deleteJobseekerQuestions(id:number): Promise<AxiosResponse<any>> {
    let data={
     provider:Constant.JOBSEEKER_PROVIDER
    } ;
     return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteJobseekerConditionalQuestions/' + id, data,
       { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
         return ag;
       }).catch(err => {
 
         if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
         }
         else if (err == "Error: Request failed with status code 500") {
           return err;
         }
         else if (err == "Error: Request failed with status code 400") {
            alert("Bad Request!");
          return err;
         } else if (err == "Error: Request failed with status code 404") {
           alert("Page Not Found!");
           localStorage.clear();
           router.push('/');
         }
         return err;
         // Manage the state of the application if the request
         // has failed
       });
   }

   public deleteJobseekerProject(id:number): Promise<AxiosResponse<any>> {
    let data={
     provider:Constant.JOBSEEKER_PROVIDER
    } ;
     return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteJobseekerProject/' + id, data,
       { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
         return ag;
       }).catch(err => {
 
         if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
         }
         else if (err == "Error: Request failed with status code 500") {
           return err;
         }
         else if (err == "Error: Request failed with status code 400") {
            alert("Bad Request!");
          return err;
         } else if (err == "Error: Request failed with status code 404") {
           alert("Page Not Found!");
           localStorage.clear();
           router.push('/');
         }
         return err;
         // Manage the state of the application if the request
         // has failed
       });
   }

  public addJobseekerEmployment(jobseekerEmployment: JobseekerEmployment): Promise<AxiosResponse<any>> {
    jobseekerEmployment.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerEmployment', jobseekerEmployment,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public createJobseekerEmployment(jobseekerEmployment: JobseekerEmployment): Promise<AxiosResponse<any>> {
    jobseekerEmployment.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/addJobseekerEmployment', jobseekerEmployment,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerLanguages(jobseekerLanguages: JobseekerLanguages, jobseekerLanguagesId): Promise<AxiosResponse<any>> {
    jobseekerLanguages.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerLanguages/' + jobseekerLanguagesId, jobseekerLanguages,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addJobseekerLanguages(jobseekerLanguages: JobseekerLanguages): Promise<AxiosResponse<any>> {
    jobseekerLanguages.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerLanguages', jobseekerLanguages,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateQuestion(question: JobseekerConditionalQuestions, quesId): Promise<AxiosResponse<any>> {
    question.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerConditionalQuestions/' + quesId, question,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateJobseekerEducation(jobseekerEducation: JobseekerEducation, jobseekerEducationId): Promise<AxiosResponse<any>> {
    jobseekerEducation.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerEducation/' + jobseekerEducationId, jobseekerEducation,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addJobseekerEducation(jobseekerEducation: JobseekerEducation): Promise<AxiosResponse<any>> {
    jobseekerEducation.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerEducation', jobseekerEducation,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;;return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public createJobseekerEducation(jobseekerEducation: JobseekerEducation): Promise<AxiosResponse<any>> {
    jobseekerEducation.provider = Constant.JOBSEEKER_PROVIDER;

    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/addJobseekerEducation', jobseekerEducation,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerPersonalDetails(jobseekerPersonalDetails: JobseekerPersonalDetails, jobseekerPersonalDetailsId): Promise<AxiosResponse<any>> {
    jobseekerPersonalDetails.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerPersonalDetails/' + jobseekerPersonalDetailsId, jobseekerPersonalDetails,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addJobseekerPersonalDetails(jobseekerPersonalDetails: JobseekerPersonalDetails): Promise<AxiosResponse<any>> {
    jobseekerPersonalDetails.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerPersonalDetails', jobseekerPersonalDetails,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerProject(jobseekerProject: JobseekerProject, jobseekerProjectId): Promise<AxiosResponse<any>> {
    jobseekerProject.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerProject/' + jobseekerProjectId, jobseekerProject,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addJobseekerProject(jobseekerProject: JobseekerProject): Promise<AxiosResponse<any>> {
    jobseekerProject.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerProject', jobseekerProject,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addMultiConditionalQuestions(data,id:number): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/addMultiConditionalQuestions/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateCareerProfile(jobseekerCareerProfile: JobseekerCareerProfile, jobseekerCareerProfileId): Promise<AxiosResponse<any>> {
    jobseekerCareerProfile.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerCareerProfile/' + jobseekerCareerProfileId, jobseekerCareerProfile,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public addJobseekerCareerProfile(jobseekerCareerProfile: JobseekerCareerProfile): Promise<AxiosResponse<any>> {
    jobseekerCareerProfile.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerCareerProfile', jobseekerCareerProfile,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseeker(jobseeker: Jobseeker, jobseekerId:any): Promise<AxiosResponse<any>> {
    let url = "";
    if(jobseeker.provider == Constant.JOBSEEKER_PROVIDER){
      url = "jobseeker/updateJobseeker/";
    }else if(jobseeker.provider == Constant.EMPLOYER_PROVIDER){
      url = "jobseekerEmployer/updateJobseeker/";
    }
    return this.axios.post(Constant.SERVER_URL + 'api/'+url + jobseekerId, jobseeker,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public uploadProfileJobseeker(req): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerProfilePic', req,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
    public applyCourseForJobseeker(req): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/approveOrRejectJobseekerForCourses', req,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateJobseekerWithoutAuth(jobseeker: Jobseeker, jobseekerId): Promise<AxiosResponse<any>> {
    jobseeker.provider = Constant.JOBSEEKER_PROVIDER;
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerWithoutAuth/' + jobseekerId, jobseeker,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerPassword(data: any, jobseekerId): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerPassword/' + jobseekerId, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateJobseekerResume(jobseeker, jobseekerId): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/uploadJobseekerResume/' + jobseekerId, jobseeker,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public uploadJobseekerVideoFile(jobseeker, jobseekerId): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/uploadJobseekerVideoFile/' + jobseekerId, jobseeker,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getPostseekerByJobpostId(id:number,profileId:number): Promise<AxiosResponse<any>> {
    let data = {
      "postjobid":id,
      "profileid":profileId,
      "provider":Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getPostSeekerByJobPost', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCurrentJobseeker(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER
    };
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getCurrentJobseeker', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!")
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public resetPasswordMailForJobseeker(data): Promise<AxiosResponse<any>> {
   let url = "";
    if(data.provider == Constant.JOBSEEKER_PROVIDER)
      url = "api/jobseeker/resetPasswordForJobseeker";
    else if(data.provider == Constant.ADMIN_PROVIDER)
      url = "api/jobseekerAdmin/resetPasswordForJobseeker";
    return this.axios.post(Constant.SERVER_URL + url, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!")
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public loginCandidate(credentials): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/jobseeker-login', credentials,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invaild Credentials!")
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getTotalJobseekerCount(data): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/jobseekerAdmin/";
    } else if(data.provider == Constant.EMPLOYER_PROVIDER){
      url = "api/jobseekerEmployer/";
    }
    else{
      url = "api/jobseeker/"
    }
    return this.axios.post(Constant.SERVER_URL + url+'getTotalJobseekerCount',data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getTotalJobseekerCountForHomePage(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getTotalJobseekerCountForHomePage',data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getJobseekersHiredCount(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getJobseekersHiredCount',data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployeeByEmployer(data,id): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/getEmployeesByEmployer/'+id,data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public searchEmployeeByEmployer(data,id): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/searchEmployeeByEmployer/'+id,data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
         localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  
  public getJobseekerStatistics(data,id): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/postjobAdmin/";
    } else if(data.provider == Constant.EMPLOYER_PROVIDER){
      url = "api/postjobEmployer/";
    }
    else{
      url = "api/jobseeker/";
    }
    return this.axios.post(Constant.SERVER_URL + url +'jobseekerDashboardStatics/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public recommendedCandidatesForJob(data): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/jobseekerAdmin/";
    } else if(data.provider == Constant.EMPLOYER_PROVIDER){
      url = "api/jobseekerEmployer/";
    }
    else{
      url = "api/jobseeker/";
    }
    return this.axios.post(Constant.SERVER_URL + url +'recommendedCandidatesForJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
           alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getTopicsBySkill(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getTopicsBySkill', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getQuestionByAssessmentId(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getQuestionByAssessmentId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public createJobseekerAssessment(jobseekerAssessment: JobseekerAssessment): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobseekerAssessment', jobseekerAssessment,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllSkillsAndAssessmentDetails(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getAllSkillsAndAssessmentDetails', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAssessmentDetailsAndScoresByJobseekerId(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getAssessmentDetailsAndScoresByJobseekerId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployeesBasedOnQuestions(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/listEmployeesBasedOnQuestions', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
    public updateJobseekerAssessment(id, jobseekerAssessment: JobseekerAssessment): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobseekerAssessment/'+id, jobseekerAssessment,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getJobSeekerOnInputSearch(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerAdmin/getJobSeekerOnInputSearch', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public bulkUploadEmployee(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/uploadEmployees', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  
  public updateJobseekerStatus(data): Promise<AxiosResponse<any>> {
    let url = "";
    if(data.provider == Constant.ADMIN_PROVIDER){
      url = "api/jobseekerAdmin/";
    }
    else if(data.provider == Constant.JOBSEEKER_PROVIDER){
      url = "api/jobseeker/";
    }
    return this.axios.post(Constant.SERVER_URL +url+ 'updateJobseekerStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public appealFromAdminStatus(data): Promise<AxiosResponse<any>> {
    let url = "api/jobseeker/";
    return this.axios.post(Constant.SERVER_URL +url+ 'updateJobseekerAppeal', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public submitTee(data): Promise<AxiosResponse<any>> {
    let url = "api/";
    return this.axios.post(Constant.SERVER_URL+ 'api/submitTee', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          //  alert("Bad Request!");
          // return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getJobSeekerByEmployerJob(data: any): Promise<AxiosResponse<any>> {
    
    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerEmployer/getJobSeekerByEmployerJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public listJobfilters(data: any): Promise<AxiosResponse<any>> {
    
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/listJobFilters', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public createJobfilters(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/createJobFilters', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public updateJobfilterStatus(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/updateJobfilterStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public deleteJobfilter(data: any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteJobfilter', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
 public getSaveJobs(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getSaveJobs', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public saveJob(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/saveJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public deleteSaveJob(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/deleteSaveJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getAllSaveJobs(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/jobseeker/getAllSaveJob', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  public listApprovedAds(data: any): Promise<AxiosResponse<any>> { 
    return this.axios.post(Constant.SERVER_URL + 'api/employerJobseeker/listAllApprovedAds', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
}

export default new JobseekerService();
